export default __webpack_public_path__ + "static/media/red.e1a3e4cb.svg";